module.exports = __webpack_public_path__ + "img/img-2.42c12a8a.png";